import type { IUser } from '@/models/IUser'
import { EmptyUser } from '@/models/IUser'
import type { ITagReferentiel } from '@/models/ITagReferentiel'
import { EmptyTagReferentiel } from '@/models/ITagReferentiel'
import type { IFile } from '@/models/IFile'

export const enum NoteTypeRelatable {
    ASSETS = 'assets',
    ASSETS_FAILURES = 'assets_failures',
    CLIENTS = 'clients',
    SUPPLIES = 'supplies',
    DOWNLINK_SEQUENCE_TRACEABILITIES = 'downlink_sequence_traceabilities',
    GARAGES = 'garages',
    ENGINS = 'engins',
    INCIDENT_SAMPLES = 'incident_samples',
    INCIDENT = 'incidents',
}

export interface INote {
    id_note: number
    id_user: number
    user: IUser
    description: string
    id_relatable: number
    type_relatable: NoteTypeRelatable
    is_admin: boolean
    is_revoked: boolean
    date_creation: string
    date_edit: string
    files: IFile[]
    tag_referentiel: ITagReferentiel
}

export const EmptyNote: INote = {
    description: '',
    user: EmptyUser,
    date_creation: '',
    date_edit: '',
    id_note: 0,
    id_relatable: 0,
    id_user: 0,
    is_admin: false,
    is_revoked: false,
    type_relatable: NoteTypeRelatable.CLIENTS,
    files: [],
    tag_referentiel: EmptyTagReferentiel,
}
